// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2PYwR","content":"ManualTimeModal_content__3a9E4"};